import CircularOutlineIcon from "@/components/CircularButton/styled/CircularOutlineIcon";
import { Flex, FlexColumn } from "@/components/Flex";
import br from "@/styles/breakpoints.module.css";
import { themeColors } from "@/utils/themeColors";
import clsx from "clsx";
import { X } from "lucide-react";
import Image from "next/image";
import styles from "../../auth.module.css";
import { useThemeContextSelector } from "@/utils/theme";
import Lottie from "lottie-react";

export const AuthMainContainer = ({ children, style, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
    return (
        <Flex style={{ height: "100dvh", backgroundColor: themeColors.neutralWhite, ...style }} {...props}>
            {children}
        </Flex>
    );
};

export const AuthLeftContainer = ({ children, style, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
    return (
        <FlexColumn
            className={clsx("scrollbar-thin", br.mdDownMaxWidthUnset, styles.mdDownAuthSidePadding)}
            style={{
                flex: 1,
                flexShrink: 0,
                maxWidth: "51rem",
                overflowY: "auto",
                paddingInline: "5rem",
                paddingBlock: "2.8rem",
                ...style,
            }}
            {...props}>
            {children}
        </FlexColumn>
    );
};

export const AuthLeftInnerContainer = ({ children, style, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
    return (
        <FlexColumn style={{ ...style }} {...props}>
            {children}
        </FlexColumn>
    );
};

export const AuthRightContainer = ({ onClose, animation }: { onClose?: () => void; animation?: any }) => {
    const isDarkMode = useThemeContextSelector(state => state.isDarkMode);

    return (
        <Flex
            className={br.mdDownDisplayNone}
            style={{
                position: "relative",
                background: !animation ? themeColors.successSecondary : "transparent",
                flex: 1,
                overflow: "hidden",
                margin: "1rem",
            }}>
            <div style={{ padding: "1rem", height: "5rem", width: "100%", position: "absolute", zIndex: 2 }}>
                {onClose && (
                    <CircularOutlineIcon
                        onClick={onClose}
                        radius="4rem"
                        Icon={X}
                        size={30}
                        color={themeColors.pureBlack}
                        hoverColor={themeColors.pureBlack}
                        sx={{ marginLeft: "auto", backgroundColor: themeColors.pureWhite, border: "none" }}
                    />
                )}
            </div>
            <div style={{ flex: 4 }} />

            {animation ? (
                <Flex
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 1,
                        height: "100%",
                        width: "auto",
                        justifyContent: "flex-end",
                    }}>
                    <Lottie animationData={animation} width={"100%"} height={"100%"} loop={false} />
                </Flex>
            ) : (
                <FlexColumn style={{ width: "88%", overflow: "hidden" }}>
                    <FlexColumn style={{ height: "15rem" }} />

                    <FlexColumn
                        style={{
                            color: themeColors.neutralBlack,
                            maxWidth: "80rem",
                            padding: "4.8rem 0rem 5rem",
                            margin: 0,
                        }}>
                        <p style={{ fontSize: "1.8rem", fontWeight: "700", marginBottom: "1.6rem" }}>
                            “This is hands down the best tool I have ever used in my life!! I just can’t believe more
                            people don’t know about this (thank you Reddit). The notes to flashcards is definitely my
                            favorite part. THANK YOU KNOWT!!!”
                        </p>
                        <p
                            style={{
                                fontSize: "1.6rem",
                                color: isDarkMode ? themeColors.neutral3 : themeColors.neutral2,
                            }}>
                            @BMarieMarris
                        </p>
                    </FlexColumn>

                    <Image
                        src={isDarkMode ? `/images/auth-dark.png` : `/images/auth-light.png`}
                        alt="overview page"
                        width="0"
                        height="0"
                        quality={100}
                        sizes="100vh"
                        style={{
                            height: "fit-content",
                            width: "100%",
                            objectFit: "cover",
                            objectPosition: "left top",
                            borderRadius: "2rem 0 0rem 2rem",
                        }}
                    />
                </FlexColumn>
            )}
        </Flex>
    );
};
